import { lazy, Suspense } from "react";
import { Flex, Loading } from "@abel-technologies-as/components";
import { useRoutes } from "react-router-dom";
import { Routes as DhcRoutes } from "@/modules/dhcs";
import { Routes as CompanyRoutes } from "@/modules/companies";
import { Routes as EndUsersRoutes } from "@/modules/end-users";
import { Routes as ProductRouts } from "@/modules/product";
import { Routes as SettingsRoutes } from "@/modules/settings";
import { PermissionGuard, SessionRestore } from "@/modules/authentication";
import { PermissionEnum } from "@/modules/authentication";

const NotFound = lazy(() => import("@/pages/NotFound"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const LoginOidc = lazy(() => import("@/pages/LoginOidc"));
const LoginGuard = lazy(() => import("@/modules/authentication/guard/Login"));

const AuthLayout = lazy(() => import("@/layouts/AuthLayout"));
const GuestLayout = lazy(() => import("@/layouts/GuestLayout"));
const BudgetEconomics = lazy(() => import("@/pages/BudgetEconomics"));

export const Router = () => {
	const authRoutes = [
		{
			path: "/",
			element: (
				<PermissionGuard permission={PermissionEnum.DashboardRead}>
					<Dashboard />
				</PermissionGuard>
			),
		},
		{
			path: "/budget-economics",
			element: (
				<PermissionGuard permission={PermissionEnum.StatisticsRead}>
					<BudgetEconomics />
				</PermissionGuard>
			),
		},
		...ProductRouts(),
		...CompanyRoutes(),
		...DhcRoutes(),
		...EndUsersRoutes(),
		...SettingsRoutes(),
	];

	const routes = useRoutes([
		{
			path: "/",
			element: <AuthLayout />,
			children: [
				...authRoutes,
				{
					path: "*",
					element: <NotFound />,
				},
			],
		},
		{
			path: "/session-restore",
			element: <SessionRestore />,
		},

		{
			path: "guest",
			element: <GuestLayout />,
			children: [
				{
					path: "",
					element: <LoginOidc />,
				},

				{
					path: "login",
					element: <LoginGuard />,
				},

				{
					path: "*",
					element: <NotFound />,
				},
			],
		},
	]);

	return (
		<Suspense
			fallback={
				<Flex width="100vw" height="100vh">
					<Loading variant="indeterminate" size="50px" />
				</Flex>
			}>
			{routes}
		</Suspense>
	);
};
